import * as React from "react";

export function useAudio(audioUrl: string, volume: number, loop: boolean) {
	React.useEffect(() => {
		const audio = new Audio(audioUrl);
		audio.loop = loop;
		audio.volume = volume;
		audio.play();
		return () => {
			audio.pause();
			audio.src = "";
			audio.load();
			audio.removeAttribute("src");
		};
	}, [audioUrl, volume, loop]);
}
